<template>
  <div class="tabs" data-testid="tabs">
    <Tabs :on-change="onChangeTab" :selected-index="currentTabIndex">
      <TabList>
        <Tab>Extratos</Tab>
        <Tab>Notas de Negociação</Tab>
      </TabList>
    </Tabs>
    <div class="tabs__filters">
      <template v-if="isLoading">
        <SkeletonLoader>
          <div class="tabs__loader__filter" />
        </SkeletonLoader>
      </template>
      <template v-else-if="shouldShowFilters">
        <FilterSelect
          :value="selectedYear || ''"
          :options="yearOptions"
          label="Ano"
          data-testid="year-filter"
          use-option-label
          @change="onChangeYear"
        />
        <!-- <ButtonSecondary
          class="tabs__button"
          label="Exportar"
          icon="EA0230"
          :loading="isExportButtonLoading"
          @click="handleExport"
        /> -->
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import {
  Tabs,
  TabList,
  Tab,
  FilterSelect,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';

import { PortfolioMontlhyStatementListFilterOption } from '@/modules/wealth/services/portfolio';

interface Props {
  currentTabIndex: number;
  selectedYear?: number | string | null;
  yearOptions: PortfolioMontlhyStatementListFilterOption[];
  isLoading: boolean;
}
const props = defineProps<Props>();

interface Emits {
  (event: 'on-change-tab', tabIndex: number): void;
  (event: 'on-change-year', year: number | string): void;
}
const emit = defineEmits<Emits>();

// const isExportButtonLoading = ref(false);

const onChangeTab = (tabIndex: number) => {
  emit('on-change-tab', tabIndex);
};

const onChangeYear = (year: number | string) => {
  emit('on-change-year', year);
};

// const handleExport = () => {
//   // TO-DO: Implement export logic
//   isExportButtonLoading.value = true;
//   setTimeout(() => {
//     isExportButtonLoading.value = false;
//   }, 2000);
// };

const shouldShowFilters = computed(
  () => props.isLoading || props.yearOptions?.length > 0
);
</script>

<style lang="less" scoped>
.tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  :deep(.tab-container) {
    white-space: nowrap;
  }

  &__loader {
    &__filter {
      height: 32px;
      width: 89px;
      border-radius: @size-radius-max;
    }
  }

  &__filters {
    display: flex;
    align-items: center;
    margin: @size-spacing-x150 0;
  }

  &__button {
    margin-left: @size-spacing-x300;
  }
}
</style>
